import React from 'react';
import { useAppDispatch } from 'hooks';

import { toggleOption } from '~weekly-planner/reducers/weeklyPlanner';

import { CommonOptions } from './CommonOptions';

interface ComponentProps {
  workerAwardAlerts: boolean;
}

export const AlertOptions: React.FC<ComponentProps> = ({ workerAwardAlerts }) => {
  const dispatch = useAppDispatch();

  const options = [
    {
      id: 'awardAlerts',
      label: 'Award Alerts',
      tooltip: 'Highlight potential award issues for worker schedules',
      checked: workerAwardAlerts,
      onChange: () => dispatch(toggleOption({ key: 'workerAwardAlerts', toggle: !workerAwardAlerts })),
    },
  ];

  return <CommonOptions title="Configure alert settings" options={options} />;
};
